import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { hideProfile, updateProfile } from "../../actions/user";
import { toMongolianPhone } from "../../utils/phone";

const UserProfile = ({ isShowing, hideProfile, user, updateProfile }) => {
  const [formData, setFormData] = useState({
    surname: "",
    givenname: "",
    phone: "",
  });
  const [phoneError, setPhoneError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Start from the saved profile every time it opens: the phone prompt may have
  // changed it since the page loaded, and unsaved edits are dropped on close.
  useEffect(() => {
    if (isShowing) {
      setFormData({
        surname: user.surname || "",
        givenname: user.givenname || "",
        phone: user.phone || "",
      });
      setPhoneError("");
    }
  }, [isShowing, user]);

  useEffect(() => {
    if (!isShowing) {
      return undefined;
    }
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        hideProfile();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isShowing, hideProfile]);

  if (!isShowing) {
    return null;
  }

  const { surname, givenname, phone } = formData;
  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    const normalized = toMongolianPhone(phone);
    if (!normalized) {
      setPhoneError("Утасны дугаар 8 оронтой байна.");
      return;
    }
    setIsSubmitting(true);
    await updateProfile({ ...formData, phone: normalized });
    setIsSubmitting(false);
  };

  return (
    <div className="modal is-active dialog-modal">
      <div className="modal-background" onClick={hideProfile}></div>
      <div className="modal-content">
        <div
          className="dialog-box"
          role="dialog"
          aria-modal="true"
          aria-labelledby="profile-title"
        >
          <button
            type="button"
            className="dialog-close"
            aria-label="Хаах"
            onClick={hideProfile}
          >
            <i className="fas fa-times" aria-hidden="true"></i>
          </button>

          <span className="dialog-icon" aria-hidden="true">
            <i className="fas fa-user"></i>
          </span>
          <h2 id="profile-title">Миний профайл</h2>
          <p className="dialog-lead">{user.email}</p>

          <form onSubmit={onSubmit}>
            <div className="dialog-row">
              <div className="field">
                <label className="dialog-label" htmlFor="profile-surname">
                  Овог
                </label>
                <input
                  id="profile-surname"
                  type="text"
                  className="input"
                  name="surname"
                  value={surname}
                  autoComplete="family-name"
                  onChange={onChange}
                />
              </div>
              <div className="field">
                <label className="dialog-label" htmlFor="profile-givenname">
                  Нэр
                </label>
                <input
                  id="profile-givenname"
                  type="text"
                  className="input"
                  name="givenname"
                  value={givenname}
                  autoComplete="given-name"
                  onChange={onChange}
                />
              </div>
            </div>

            <div className="field">
              <label className="dialog-label" htmlFor="profile-phone">
                Утасны дугаар
              </label>
              <div className="control has-icons-left">
                <input
                  id="profile-phone"
                  type="tel"
                  inputMode="numeric"
                  className={`input ${phoneError ? "is-danger" : ""}`}
                  name="phone"
                  value={phone}
                  placeholder="99112233"
                  autoComplete="tel"
                  aria-invalid={Boolean(phoneError)}
                  aria-describedby="profile-phone-help"
                  onChange={(e) => {
                    onChange(e);
                    setPhoneError("");
                  }}
                />
                <span className="icon is-left">
                  <i className="fas fa-phone" aria-hidden="true"></i>
                </span>
              </div>
              <p
                id="profile-phone-help"
                className={phoneError ? "dialog-help" : "dialog-hint"}
              >
                {phoneError ||
                  "Хэвлэх үед алдаа гарвал админ энэ дугаараар холбогдоно."}
              </p>
            </div>

            <button
              type="submit"
              className={`button is-fullwidth dialog-submit ${
                isSubmitting ? "is-loading" : ""
              }`}
              disabled={isSubmitting}
            >
              Хадгалах
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

UserProfile.propTypes = {
  isShowing: PropTypes.bool,
  hideProfile: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  updateProfile: PropTypes.func.isRequired,
};

export default connect(null, { hideProfile, updateProfile })(UserProfile);
